import { HostRemovalReason, PlayerLeaveReason } from '@core-http';

export const playerLeaveReasonMapper: Record<PlayerLeaveReason, string> = {
  [PlayerLeaveReason.PLANS_CHANGED]: 'Zmieniły mi się plany',
  [PlayerLeaveReason.SCHEDULE_CONFLICT]: 'Nie pasuje mi termin',
  [PlayerLeaveReason.CANNOT_ARRIVE_ON_TIME]: 'Nie mogę dotrzeć na czas',
  [PlayerLeaveReason.INJURY]: 'Mam kontuzję',
  [PlayerLeaveReason.PREFER_NOT_TO_SAY]: 'Nie chcę podawać powodu',
  [PlayerLeaveReason.OTHER]: 'Inny powód'
};

export const hostRemovalReasonMapper: Record<HostRemovalReason, string> = {
  [HostRemovalReason.MISMATCHED_LEVEL]: 'Nieodpowiedni poziom gracza',
  [HostRemovalReason.INCOMPLETE_PROFILE]: 'Nieuzupełniony profil',
  [HostRemovalReason.FRIENDS_ONLY]: 'Gierka tylko dla znajomych',
  [HostRemovalReason.LOOKING_FOR_OTHER_POSITION]: 'Poszukiwani gracze na inną pozycję',
  [HostRemovalReason.PREFER_NOT_TO_SAY]: 'Nie chcę podawać powodu',
  [HostRemovalReason.OTHER]: 'Inny powód'
};
